import { requester } from '../utils';

export const getAllTickets = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/ticket/me`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get user all tickets error', err);
        reject(err);
      });
  });
};

export const ticketDetails = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/ticket/me/details`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get user ticket details error', err);
        reject(err);
      });
  });
};

export const replyTicket = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/ticket/me/reply`,
        method: 'PUT',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('reply to my ticket error', err);
        reject(err);
      });
  });
};

export const sendNewTicket = (data) => {
    return new Promise((resolve, reject) => {
      requester
        .fetchAPI({
          route: `v1/ticket/me/send`,
          method: 'POST',
          withAuth: true,
          data,
        })
        .then((result) => {
          resolve(result.payload);
        })
        .catch((err) => {
          console.log('send new ticket error', err);
          reject(err);
        });
    });
  };
